import { select, takeEvery, put, call, fork } from 'redux-saga/effects'

import * as auth from '../auth'
import { indicateProgress } from '../api'
import { apiLanguageCodeSelector } from '../i18n/selectors'
import { getReservationConfirmation } from 'grs/api'
import { guestUserPersonalDataSelector } from 'booking/selectors'

import * as constants from './constants'
import * as actions from './actions'

export function* getReservationConfirmationSaga() {
    yield takeEvery(constants.GET_RESERVATION_CONFIRMATION, function* ({ reservationId }) {
        const user = yield select(auth.selectors.userSelector)
        const guestUser = yield select(guestUserPersonalDataSelector)
        const apiLanguageCode = yield select(apiLanguageCodeSelector)

        const { parkingPassUrl, parkingPassRequirements } = yield call(
            indicateProgress,
            ['reservationConfirmation'],
            getReservationConfirmation,
            reservationId,
            user?.email || guestUser?.email,
            apiLanguageCode
        )

        yield put(actions.getReservationConfirmationResponse(parkingPassUrl, parkingPassRequirements))
    })
}

export default function* rootSaga() {
    yield fork(getReservationConfirmationSaga)
}
